function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import digest from '../runtime/digest.js';
import { encode as base64url } from '../runtime/base64url.js';
import { JOSENotSupported, JWKInvalid } from '../util/errors.js';
import { encoder } from '../lib/buffer_utils.js';
import isObject from '../lib/is_object.js';
var check = function check(value, description) {
  if (typeof value !== 'string' || !value) {
    throw new JWKInvalid("".concat(description, " missing or invalid"));
  }
};
export function calculateJwkThumbprint(_x, _x2) {
  return _calculateJwkThumbprint.apply(this, arguments);
}
function _calculateJwkThumbprint() {
  _calculateJwkThumbprint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(jwk, digestAlgorithm) {
    var _digestAlgorithm;
    var components, data, _t, _t2, _t3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isObject(jwk)) {
            _context.n = 1;
            break;
          }
          throw new TypeError('JWK must be an object');
        case 1:
          (_digestAlgorithm = digestAlgorithm) !== null && _digestAlgorithm !== void 0 ? _digestAlgorithm : digestAlgorithm = 'sha256';
          if (!(digestAlgorithm !== 'sha256' && digestAlgorithm !== 'sha384' && digestAlgorithm !== 'sha512')) {
            _context.n = 2;
            break;
          }
          throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
        case 2:
          _t = jwk.kty;
          _context.n = _t === 'EC' ? 3 : _t === 'OKP' ? 4 : _t === 'RSA' ? 5 : _t === 'oct' ? 6 : 7;
          break;
        case 3:
          check(jwk.crv, '"crv" (Curve) Parameter');
          check(jwk.x, '"x" (X Coordinate) Parameter');
          check(jwk.y, '"y" (Y Coordinate) Parameter');
          components = {
            crv: jwk.crv,
            kty: jwk.kty,
            x: jwk.x,
            y: jwk.y
          };
          return _context.a(3, 8);
        case 4:
          check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
          check(jwk.x, '"x" (Public Key) Parameter');
          components = {
            crv: jwk.crv,
            kty: jwk.kty,
            x: jwk.x
          };
          return _context.a(3, 8);
        case 5:
          check(jwk.e, '"e" (Exponent) Parameter');
          check(jwk.n, '"n" (Modulus) Parameter');
          components = {
            e: jwk.e,
            kty: jwk.kty,
            n: jwk.n
          };
          return _context.a(3, 8);
        case 6:
          check(jwk.k, '"k" (Key Value) Parameter');
          components = {
            k: jwk.k,
            kty: jwk.kty
          };
          return _context.a(3, 8);
        case 7:
          throw new JOSENotSupported('"kty" (Key Type) Parameter missing or unsupported');
        case 8:
          data = encoder.encode(JSON.stringify(components));
          _t2 = base64url;
          _context.n = 9;
          return digest(digestAlgorithm, data);
        case 9:
          _t3 = _context.v;
          return _context.a(2, _t2(_t3));
      }
    }, _callee);
  }));
  return _calculateJwkThumbprint.apply(this, arguments);
}
export function calculateJwkThumbprintUri(_x3, _x4) {
  return _calculateJwkThumbprintUri.apply(this, arguments);
}
function _calculateJwkThumbprintUri() {
  _calculateJwkThumbprintUri = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(jwk, digestAlgorithm) {
    var _digestAlgorithm2;
    var thumbprint;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          (_digestAlgorithm2 = digestAlgorithm) !== null && _digestAlgorithm2 !== void 0 ? _digestAlgorithm2 : digestAlgorithm = 'sha256';
          _context2.n = 1;
          return calculateJwkThumbprint(jwk, digestAlgorithm);
        case 1:
          thumbprint = _context2.v;
          return _context2.a(2, "urn:ietf:params:oauth:jwk-thumbprint:sha-".concat(digestAlgorithm.slice(-3), ":").concat(thumbprint));
      }
    }, _callee2);
  }));
  return _calculateJwkThumbprintUri.apply(this, arguments);
}